export enum ReduxMainMediaProps {
	MAIN_MEDIA = 'mainMedia',
}

export const watermarkProp = 'mainMediaWatermark';
